<!--
 * @Description: 数据前处理
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="675" :itemWidth="420 + 56">
      <div v-for="(item, index) in TYPE_MAPPING" :key="index">
        <div
          class="xrk-card"
          @click="onChange(item.value)"
          style="width: 420px; height: 600px"
        >
          <div
            :style="{
              width: '100%',
              height: '600px',
              'border-radius': '2px',
              position: 'absolute',
              top: '0',
              left: '0',
              boxSizing: 'border-box',
              padding: '0 20px'
            }"
          >
            <component
              v-if="subTitleCmpt"
              :is="subTitleCmpt"
              v-bind="{
                innerText: '数据前处理'
              }"
            />

            <component
              style="
                width: 1200px;
                transform: scale(0.32);
                transform-origin: 0 0;
              "
              :is="cmpName(item.value)"
              :tableHeaderList="data_4_1.table.header"
              :tableDataList="data_4_1.table.value"
            />

            <component
              style="width: 60px; height: 30px"
              v-if="pageNoCmpt"
              :is="pageNoCmpt"
            />
          </div>
        </div>
        <div class="bi-tmpl-detail__right__cmpt__radioBox">
          <BaseRadio
            :value="item.value"
            :model-value="curItem.value"
            @click="onChange(item.value)"
          >
            {{}}
          </BaseRadio>
        </div>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import PcModuleCase from '../../../bi-pc-module/pc-module-case/index';
import { data_4_1 } from '../../../../hooks/use-preview';

import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';

const TYPE_MAPPING = [1, 2, 3, 4, 5, 6].map(i => {
  return {
    value: 'pc-module-case-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleCase.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, subTitleCmpt, pageNoCmpt } = useDetailCmpt({});
</script>
<style lang="scss" scope></style>
